module.exports = __webpack_public_path__ + "static/media/404logo.e6e959c0.svg";